export default {
  table: {},
  tab: [],
  renderDetail: {},
  detailData: {},
  tabActive: {},
  subTable: {
    column: [
      {
        headerName: "วันที่",
        field: "date_createdAt",
        width: 250,
        filter: true,
        cellRendererFramework: "CheckboxText",
      },
      {
        headerName: "Task no.",
        field: "task_code",
        width: 180,
        filter: true,
        cellRendererFramework: "CheckboxText",
      },
      {
        headerName: "รายละเอียด",
        field: "task_name",
        filter: true,
        width: 150,
        cellRendererFramework: "String",
      },
      {
        headerName: "เดือน/ปี ที่ให้บริการ",
        field: "date",
        filter: true,
        width: 150,
        cellRendererFramework: "Date",
      },
      {
        headerName: "หมายเหตุ",
        field: "note",
        filter: true,
        width: 150,
        cellRendererFramework: "String",
      },
      {
        headerName: "จำนวนเงิน",
        field: "price",
        filter: true,
        width: 150,
        cellRendererFramework: "Float",
      },
      {
        headerName: "ภาษีหัก ณ ที่จ่าย",
        field: "tax",
        filter: true,
        width: 150,
        cellRendererFramework: "Percent",
      },
      {
        headerName: "ยอดสุทธิ",
        field: "net",
        filter: true,
        width: 150,
        cellRendererFramework: "Float",
      },
      {
        headerName: "",
        field: "more",
        filter: true,
        width: 150,
        cellRendererFramework: "More",
      },
    ],
    data: [
      {
        date_createdAt: "2021-03-29T10:48:17.000Z",
        task_code: "T2021MAR0003NEWC",
        task_name: "ภ.ง.ด.1",
        note: "",
        price: 400,
        tax: null,
        net: 400,
        date: "2021-01-31T17:00:00.000Z",
        dropdown: 221,
        more: [
          { name: "แก้ไข Task", value: 221, path: null, menu_type: "Edit" },
          { name: "ลบ Task", value: 221, path: null, menu_type: "Delete" },
        ],
      },
    ],
  },
};
